import { Route } from '@angular/router';

// Compatibilidad con favoritos y enlaces compartidos antes de agrupar el panel.
export const CHAT_SUPERVISION_REDIRECT: Route = {
  path: 'administracion-chat', pathMatch: 'full', redirectTo: '/coordinador/chat',
};
